import { forwardRef, useImperativeHandle } from 'react';
import './AssignedStudentCourses.scss';
import { useGetAssignedStudentCourses } from './AssignedStudentCoursesHooks';
import { useAssignedStudentCoursesTable } from './AssignedStudentCoursesTableHooks';
import SearchAndSortableTable from '../../../components/table/SearchAndSortableTable';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';

const defaultProps = {
  loading: false,
  selectedDates: {},
  onStartLoading: () => null,
  subjectId: null,
  onDataLoad: () => null,
  assignedStudentCourses: [],
  filterCriteriaAssignedStudentCourses: {},
  canArchive: true,
  onTableActionSuccess: () => null,
  canLessonDeleteFunction: () => true,
};

const AssignedStudentCourses = forwardRef((props, ref) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const {
    loading,
    selectedDates,
    onStartLoading,
    subjectId,
    onDataLoad,
    assignedStudentCourses,
    filterCriteriaAssignedStudentCourses,
    canArchive,
    onTableActionSuccess,
    canLessonDeleteFunction,
  } = mergedProps;
  const {
    filteredAssignedStudentCourses,
    getAssignedStudentData,
  } = useGetAssignedStudentCourses({
    onStartLoading,
    subjectId,
    onDataLoad,
    assignedStudentCourses,
    filterCriteriaAssignedStudentCourses,
  });

  const {
    tableConfig,
  } = useAssignedStudentCoursesTable({
    onDataLoad,
    assignedStudentCourses,
    selectedDates,
    getAssignedStudentData,
    canArchive,
    onTableActionSuccess,
    canLessonDeleteFunction,
  });

  useImperativeHandle(ref, () => ({
    refreshData: () => {
      getAssignedStudentData(selectedDates);
    },
  }));

  return (
    <div className='assigned-students-courses'>
      <SearchAndSortableTable
        containerClassName='assigned-student-course-table'
        config={tableConfig}
        tableData={filteredAssignedStudentCourses}
        searchPlaceholder='FILTER STUDENTS'
        initTableState={{
          order: 'desc', // needs to figure out whey it is 'desc' to order the date
          orderBy: 'date',
        }}
        filterable={false}
        loading={loading}
        autoResetTableState={false}
      />
    </div>
  );
});

export default AssignedStudentCourses;
